// extracted by mini-css-extract-plugin
module.exports =  {"dashboard":"dashboard__EJkJr"};